<template>
  <div>栏目管理</div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods:{
    }, 
    mounted() {
            console.log(133333);
    }
};
</script>


<style>

</style>